module.exports = __webpack_public_path__ + "static/media/map.463985b3.png";